<script lang="ts">
    import { onMount } from "svelte";
    import { useNavigate } from "svelte-navigator";
    import * as _ from "underscore";
    import {
        OrganisationCreationRequest,
        OrganisationRole,
    } from "../../../../../admin-service-typescript-client";
    import type { UserCreationRequest } from "../../../../../admin-service-typescript-client/models/UserCreationRequest";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { user } from "../../../../store/stores";
    import { usersStore } from "../../../../store/users";
    import PermissionsTable from "./Components/PermissionsTable.svelte";

    const navigate = useNavigate();

    let newUser: OrganisationCreationRequest = {
        active: false,
        name: "",
    };

    let passwordControl = "";
    let individualPermissions = [];
    let fetching: boolean = false;
    let status: boolean | null = null;
    let errorMessage: string = "Die Erstellung ist fehlgeschlagen.";

    // const changePermissionsHandler = (permissions: Permission[]) => {
    //     individualPermissions = permissions;
    // };

    // $: {
    //     newUser.permissions = _.uniq(
    //         (newUser.permissions = mapRolesToPermission(
    //             $usersStore.roles
    //         ).concat(individualPermissions))
    //     );
    // }

    const getRolesPermissionMapping = async () => {
        // await $user.updateToken().then(async () => {
        //     await ApiClient.getInstance($user)
        //         .userClient.get()
        //         .then((roles) =>
        //             usersStore.update((usersStore) => {
        //                 return {
        //                     ...usersStore,
        //                     roles: { ...roles },
        //                 };
        //             })
        //         );
        // });
    };

    const createNewOrganisation = async () => {
        if (newUser.name) {
            await $user.updateToken().then(async () => {
                ApiClient.getInstance()
                    .organisationClient.createOrganisation({
                        organisationCreationRequest: {
                            ...newUser,
                            organisationRoles: [OrganisationRole.NetworkOwner],
                        },
                    })
                    .then((result) => {
                        fetching = false;
                        status = true;
                    })
                    .catch((error) => {
                        fetching = false;
                        status = false;
                        errorMessage = error;
                    });
            });
        }
    };

    onMount(() => {
        getRolesPermissionMapping();
    });
</script>

<div class="container">
    <section class="section">
        <h1 class="title">Neue Organisation</h1>
    </section>

    <div class="box">
        <div class="columns">
            <div class="column is-12">
                {#if status}
                    <div class="notification is-success">
                        <button
                            class="delete"
                            on:click={() => (status = null)}
                        />
                        <p>
                            Die Organisation <b>{newUser.name}</b> wurde angelegt.
                        </p>
                    </div>
                {:else if status === false}
                    <div
                        class="notification is-danger"
                        on:click={() => (status = null)}
                    >
                        <button class="delete" />
                        <p>{errorMessage}</p>
                    </div>
                {/if}

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label for="username" class="label field-name">
                            Name
                        </label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input
                                    class="input"
                                    type="text"
                                    placeholder="Username"
                                    name="username"
                                    bind:value={newUser.name}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <!-- svelte-ignore a11y-label-has-associated-control -->
                        <label class="label field-name">Status</label>
                    </div>
                    <div class="field-body">
                        <div class="select">
                            <select bind:value={newUser.active}>
                                <option value={true}>aktiv</option>
                                <option value={false}>deaktiviert</option>
                            </select>
                        </div>
                    </div>
                </div>
                <!-- <div class="column is-12">
                    <div class="box">
                        <p class="is-size-5">Rollen</p>
                        <div class="columns">
                            <div class="column">
                                <div class="tags">
                                    {#each Object.keys(Role).filter((key) => newUser.roles.findIndex((role) => role === Role[key]) < 0) as role}
                                        <span
                                            class="tag is-warning"
                                            on:click={() => {
                                                newUser.roles =
                                                    newUser.roles.concat([
                                                        Role[role],
                                                    ]);
                                            }}>{role}</span
                                        >
                                    {/each}
                                </div>
                            </div>
                            <div class="column">
                                <div class="tags">
                                    {#each newUser.roles as role}
                                        <span class="tag is-primary"
                                            >{role}<button
                                                class="delete is-small"
                                                on:click={() =>
                                                    (newUser.roles =
                                                        newUser.roles.filter(
                                                            (filterRole) =>
                                                                filterRole !==
                                                                role
                                                        ))}
                                            /></span
                                        >
                                    {/each}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="column is-12">
                    <!-- <div class="box">
                        <PermissionsTable
                            permissions={newUser.permissions}
                            editable
                            {changePermissionsHandler}
                        />
                    </div> -->
                </div>
                <div
                    class="field is-grouped is-flex is-justify-content-space-between"
                >
                    <div class="control">
                        <button
                            class="button is-link is-light"
                            on:click={() => navigate(-1)}>Abbrechen</button
                        >
                    </div>
                    <div class="control">
                        <button
                            class="button is-success is-light {fetching
                                ? 'is-loading'
                                : ''}"
                            disabled={newUser.name === ""}
                            on:click={() => createNewOrganisation()}
                            >Erstellen</button
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .field-name {
        text-align: left;
    }
</style>
